import React from "react";
import Multibanco from '../../../assets/svg/multibanco.svg';
import FrameBlockResult from '../FrameBlockResult';
import { ApmsTypes } from "../../../constants";

const MultibancoResult = ({ link }) => {
    return (
        <FrameBlockResult link={link} apmType={ApmsTypes.Multibanco} icon={Multibanco} />
    )
}

export default MultibancoResult;